/*
 * @Description: 商城配置数据
 * @Autor: WangYuan
 * @Date: 2021-09-28 15:05:58
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-11-02 09:44:23
 */

export const mallTypeList = [
    {
        type: 'mall',
        logo: 'https://cdn.zhaosheng.daheyun1314.com/person/8fc9932a28f6498a8c4d2e3b672ad7e9.png',
        title: '应用管理',
        subTitle: ' E-commence'
    }
    /*  ,
      {
          type: 'model',
          logo: 'http://110.41.150.71:8090/img/1667353421573.png',
          title: '商城模板',
          subTitle: ' E-commenceModel'
      },*/
]

export const mallIndustryList = [
    { label: '日用百货', value: 'department' },
    { label: '服饰饰品', value: 'clothes' },
    { label: '休闲零食', value: 'snacks' },
    { label: '数码家电', value: 'digital' },
    { label: '教育培训', value: 'education' },
    { label: '酒店旅游', value: 'hotel' },
    { label: '其他', value: 'other' },
]